/* =================================================================
   norsu Wishlist — lightweight localStorage wishlist (no app)
   File: assets/norsu-wishlist.js
   - Toggles .js-wishlist-btn hearts on col-cards (collection/search)
   - Renders saved products on /pages/wishlist ([data-nrs-wishlist])
   Storage: localStorage "norsu_wishlist" = JSON array of handles.
   ================================================================= */
(function () {
  'use strict';

  var KEY = 'norsu_wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.unshift(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1;
  }

  /* --- Heart buttons (event delegation — survives load-more) ----- */

  function syncHearts(root) {
    var list = read();
    (root || document).querySelectorAll('.js-wishlist-btn[data-handle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-wishlist-btn[data-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(btn.getAttribute('data-handle'));
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }, true);

  /* Re-sync when load-more / filters swap cards in */
  var syncQueued = false;
  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () { syncQueued = false; syncHearts(); });
  }
  if (window.MutationObserver) {
    new MutationObserver(queueSync).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* --- Wishlist page ------------------------------------------------ */

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function sharedHandles() {
    var v = new URLSearchParams(location.search).get('items');
    if (!v) return null;
    return v.split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, 80);
  }

  function renderPage(wrap) {
    var grid = wrap.querySelector('[data-nrs-wishlist-grid]');
    var empty = wrap.querySelector('[data-nrs-wishlist-empty]');
    var shared = sharedHandles();
    var readOnly = shared !== null;
    var list = readOnly ? shared : read();

    var sharedNote = wrap.querySelector('[data-nrs-shared-note]');
    var shareBtn = wrap.querySelector('[data-nrs-share]');
    if (sharedNote) sharedNote.hidden = !readOnly;
    if (shareBtn) shareBtn.hidden = readOnly || !list.length;

    if (!list.length) {
      grid.hidden = true;
      empty.hidden = false;
      return;
    }
    grid.hidden = false;
    empty.hidden = true;
    grid.innerHTML = '';

    list.forEach(function (handle) {
      var cell = document.createElement('div');
      cell.className = 'nwl-card';
      cell.setAttribute('data-handle', handle);
      grid.appendChild(cell);

      fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) {
          var img = (p.featured_image || (p.images && p.images[0]) || '');
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          if (img) img = img.replace(/(\.[a-z]{3,4})(\?|$)/, '_540x$1$2');
          var soldOut = !p.available;
          cell.innerHTML =
            '<a class="nwl-card__media" href="' + p.url + '">' +
              (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
              (soldOut ? '<span class="nwl-card__soldout">Sold out</span>' : '') +
            '</a>' +
            '<div class="nwl-card__body">' +
              '<a class="nwl-card__title" href="' + p.url + '"></a>' +
              '<p class="nwl-card__price">' + money(p.price) + '</p>' +
              '<div class="nwl-card__actions">' +
                '<a class="na-btn nwl-card__view" href="' + p.url + '">View product</a>' +
                (readOnly ? '' : '<button class="nwl-card__remove" type="button" data-remove="' + handle + '">Remove</button>') +
              '</div>' +
            '</div>';
          cell.querySelector('.nwl-card__title').textContent = p.title;
        })
        .catch(function () {
          /* product deleted/hidden — drop it silently */
          if (!readOnly) {
            var l = read();
            var i = l.indexOf(handle);
            if (i !== -1) { l.splice(i, 1); write(l); }
          }
          cell.remove();
          if (!readOnly && !read().length) renderPage(wrap);
        });
    });
  }

  function bindPage(wrap) {
    /* Remove (delegated once) */
    wrap.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove]');
      if (!rm) return;
      var l = read();
      var i = l.indexOf(rm.getAttribute('data-remove'));
      if (i !== -1) { l.splice(i, 1); write(l); }
      var card = rm.closest('.nwl-card');
      if (card) card.remove();
      if (!read().length) renderPage(wrap);
    });

    /* Share my wishlist */
    var shareBtn = wrap.querySelector('[data-nrs-share]');
    var shareDone = wrap.querySelector('[data-nrs-share-done]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = location.origin + '/pages/wishlist?items=' + read().join(',');
        function copied() {
          if (!shareDone) return;
          shareDone.hidden = false;
          setTimeout(function () { shareDone.hidden = true; }, 3000);
        }
        if (navigator.share) {
          navigator.share({ title: 'My norsu wishlist', url: url }).catch(function () {});
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(copied, copied);
        } else {
          window.prompt('Copy this link to share your wishlist:', url);
        }
      });
    }

    /* Save a shared wishlist into mine */
    var saveShared = wrap.querySelector('[data-nrs-save-shared]');
    if (saveShared) {
      saveShared.addEventListener('click', function () {
        var mine = read();
        (sharedHandles() || []).forEach(function (h) {
          if (mine.indexOf(h) === -1) mine.push(h);
        });
        write(mine);
        location.href = '/pages/wishlist';
      });
    }
  }

  function init() {
    syncHearts();
    var wrap = document.querySelector('[data-nrs-wishlist]');
    if (wrap) { bindPage(wrap); renderPage(wrap); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
